// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolCreateBody = {
  name: string;
  sportKey: string;
  leagueKey: string;
  contestType: "survivor" | "squares" | "stripCard" | "pickem";
  joinPolicy?: "open" | "approval";
  visibility?: "public" | "private";
  autoApprove?: boolean;
  memberSharingEnabled?: boolean;
  chatEnabled?: boolean;
  maxMembers?: number | null;
  quickStartId?: string;
  seasonYear?: number;
  squaresSetup?: {
    gridType: "classic" | "shared";
    gameRule: {
      presetKey:
        | "oneGame"
        | "allGames"
        | "tnf"
        | "snf"
        | "mnf"
        | "thanksgiving"
        | "christmas"
        | "playoffs"
        | "conference"
        | "team"
        | "bowls"
        | "cfp"
        | "ncaaTournament"
        | "conferenceTournaments"
        | "openingDay"
        | "worldSeries"
        | "matchdayRange"
        | "customDates";
      seasonYear?: number | null;
      eventId?: string | null;
      teamId?: string | null;
      conferenceKey?: string | null;
      customDates?: {
        mode: "range" | "dates";
        fromDay?: string;
        toDay?: string;
        days?: string[];
      } | null;
      excludedEventIds: string[];
    };
    axes: {
      kind:
        "teamNames" | "winnerLoser" | "homeAway" | "teamOpponent" | "custom";
      topLabel?: string | null;
      sideLabel?: string | null;
      teamId?: string | null;
    };
    checkpoints: string[];
    gridSettings: {
      size: number;
      maxPerMember?: number | null;
      autoLock: boolean;
      showNumbers: boolean;
    };
    newGrid: {
      carrySquares: boolean;
      redrawNumbers: boolean;
      autoPublish: boolean;
    };
  } | null;
  stripCardSetup?: {
    eventId?: string | null;
    customGameTitle?: string | null;
    maxSpotsPerMember: number | null;
  } | null;
  pickemSetup?: {
    scoringFormat: "standard" | "confidence";
    picksRequiredMode: "all" | "count";
    picksRequiredCount?: number | null;
    pickBasis: "moneyline" | "spread";
    tiebreaker: "none" | "totalPoints";
    tiePolicy: "tieIsWin" | "tieIsLoss" | "tieIsVoid";
    winPoints: number;
    lossPoints: number;
    roundGrouping: "day" | "week";
    weekStartDay?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    endDateMode: "date" | "tbd";
  } | null;
};

export type typePoolCreateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    poolId: string;
    poolRefId?: string | null;
    name: string;
    joinCode: string;
    joinUrl: string;
    visibility: "public" | "private";
    autoApprove: boolean;
    memberSharingEnabled: boolean;
    chatEnabled: boolean;
    contestId?: string;
    seasonId?: string;
    squaresSeasonId?: string;
  };
};

export type typePoolCreateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolCreateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolCreateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolCreateBody = {
  type: "object",
  properties: {
    name: { type: "string", maxLength: 3000, minLength: 1 },
    sportKey: { type: "string", maxLength: 3000, minLength: 1 },
    leagueKey: { type: "string", maxLength: 3000, minLength: 1 },
    contestType: {
      type: "string",
      enum: ["survivor", "squares", "stripCard", "pickem"],
    },
    joinPolicy: { type: "string", enum: ["open", "approval"] },
    visibility: { type: "string", enum: ["public", "private"] },
    autoApprove: { type: "boolean" },
    memberSharingEnabled: { type: "boolean" },
    chatEnabled: { type: "boolean" },
    maxMembers: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    quickStartId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonYear: { type: "integer" },
    squaresSetup: {
      oneOf: [
        {
          type: "object",
          properties: {
            gridType: { type: "string", enum: ["classic", "shared"] },
            gameRule: {
              type: "object",
              properties: {
                presetKey: {
                  type: "string",
                  enum: [
                    "oneGame",
                    "allGames",
                    "tnf",
                    "snf",
                    "mnf",
                    "thanksgiving",
                    "christmas",
                    "playoffs",
                    "conference",
                    "team",
                    "bowls",
                    "cfp",
                    "ncaaTournament",
                    "conferenceTournaments",
                    "openingDay",
                    "worldSeries",
                    "matchdayRange",
                    "customDates",
                  ],
                },
                seasonYear: { oneOf: [{ type: "integer" }, { enum: [null] }] },
                eventId: {
                  oneOf: [
                    { type: "string", maxLength: 3000, minLength: 1 },
                    { enum: [null] },
                  ],
                },
                teamId: {
                  oneOf: [
                    { type: "string", maxLength: 3000, minLength: 1 },
                    { enum: [null] },
                  ],
                },
                conferenceKey: {
                  oneOf: [
                    { type: "string", maxLength: 3000, minLength: 1 },
                    { enum: [null] },
                  ],
                },
                customDates: {
                  oneOf: [
                    {
                      type: "object",
                      properties: {
                        mode: { type: "string", enum: ["range", "dates"] },
                        fromDay: {
                          type: "string",
                          maxLength: 3000,
                          minLength: 1,
                        },
                        toDay: {
                          type: "string",
                          maxLength: 3000,
                          minLength: 1,
                        },
                        days: {
                          type: "array",
                          items: {
                            type: "string",
                            maxLength: 3000,
                            minLength: 1,
                          },
                        },
                      },
                      required: ["mode"],
                    },
                    { enum: [null] },
                  ],
                },
                excludedEventIds: {
                  type: "array",
                  items: { type: "string", maxLength: 3000, minLength: 1 },
                },
              },
              required: ["presetKey", "excludedEventIds"],
            },
            axes: {
              type: "object",
              properties: {
                kind: {
                  type: "string",
                  enum: [
                    "teamNames",
                    "winnerLoser",
                    "homeAway",
                    "teamOpponent",
                    "custom",
                  ],
                },
                topLabel: {
                  oneOf: [
                    { type: "string", maxLength: 3000, minLength: 1 },
                    { enum: [null] },
                  ],
                },
                sideLabel: {
                  oneOf: [
                    { type: "string", maxLength: 3000, minLength: 1 },
                    { enum: [null] },
                  ],
                },
                teamId: {
                  oneOf: [
                    { type: "string", maxLength: 3000, minLength: 1 },
                    { enum: [null] },
                  ],
                },
              },
              required: ["kind"],
            },
            checkpoints: {
              type: "array",
              items: { type: "string", maxLength: 3000, minLength: 1 },
            },
            gridSettings: {
              type: "object",
              properties: {
                size: { type: "integer" },
                maxPerMember: {
                  oneOf: [{ type: "integer" }, { enum: [null] }],
                },
                autoLock: { type: "boolean" },
                showNumbers: { type: "boolean" },
              },
              required: ["size", "autoLock", "showNumbers"],
            },
            newGrid: {
              type: "object",
              properties: {
                carrySquares: { type: "boolean" },
                redrawNumbers: { type: "boolean" },
                autoPublish: { type: "boolean" },
              },
              required: ["carrySquares", "redrawNumbers", "autoPublish"],
            },
          },
          required: [
            "gridType",
            "gameRule",
            "axes",
            "checkpoints",
            "gridSettings",
            "newGrid",
          ],
        },
        { enum: [null] },
      ],
    },
    stripCardSetup: {
      oneOf: [
        {
          type: "object",
          properties: {
            eventId: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            customGameTitle: {
              oneOf: [{ type: "string", maxLength: 40 }, { enum: [null] }],
            },
            maxSpotsPerMember: {
              oneOf: [{ type: "integer" }, { enum: [null] }],
            },
          },
          required: ["maxSpotsPerMember"],
        },
        { enum: [null] },
      ],
    },
    pickemSetup: {
      oneOf: [
        {
          type: "object",
          properties: {
            scoringFormat: { type: "string", enum: ["standard", "confidence"] },
            picksRequiredMode: { type: "string", enum: ["all", "count"] },
            picksRequiredCount: {
              oneOf: [{ type: "integer" }, { enum: [null] }],
            },
            pickBasis: { type: "string", enum: ["moneyline", "spread"] },
            tiebreaker: { type: "string", enum: ["none", "totalPoints"] },
            tiePolicy: {
              type: "string",
              enum: ["tieIsWin", "tieIsLoss", "tieIsVoid"],
            },
            winPoints: { type: "integer" },
            lossPoints: { type: "integer" },
            roundGrouping: { type: "string", enum: ["day", "week"] },
            weekStartDay: { oneOf: [{ type: "integer" }, { enum: [null] }] },
            startDate: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            endDate: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            endDateMode: { type: "string", enum: ["date", "tbd"] },
          },
          required: [
            "scoringFormat",
            "picksRequiredMode",
            "pickBasis",
            "tiebreaker",
            "tiePolicy",
            "winPoints",
            "lossPoints",
            "roundGrouping",
            "endDateMode",
          ],
        },
        { enum: [null] },
      ],
    },
  },
  required: ["name", "sportKey", "leagueKey", "contestType"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolCreate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolCreateBody);
  }

  return async function postPoolCreate(
    payload: typePoolCreateBody,
  ): Promise<typePoolCreateOutput200 | typePoolCreateOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolCreate" failed before calling the network. #bac52c892a90`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#bac52c892a90" },
        },
        data: null,
      } as typePoolCreateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/create`,
      httpMethod: "POST",
      options,
    })) as typePoolCreateOutput200 | typePoolCreateOutput400;
  };
}
